import { getConfig } from '@b2ag/micro-front-tools'

export function getConfigProduct() {
  return {
    productApiHost: getConfig('PRODUCT_API_HOST'),
  }
}
